import { useMe } from "@podtrac/common/accounts";
import React from "react";
import { FaUserCircle } from "react-icons/fa";
//import { useEndSession } from "../api/session";
import DropMenu from "./InaccessibleMenu";

import styles from "./UserMenu.module.scss";

export default function UserMenu({ editProfile }) {
    const { isLoading, isSuccess, data } = useMe();
    const profile = data?.me;
    //const endSession = useEndSession();

    const handleProfile = event => {
        editProfile();
    };

    const handleSignOut = event => {
        window.location = "/account/logout";
    };

    return (
        <DropMenu position="left">
            {({
                isOpen,
                createWrapperProps,
                createButtonProps,
                createMenuProps,
                createItemProps
            }) => (
                <nav
                    {...createWrapperProps({
                        className: `${ styles.userMenu } ${ styles.dropMenu } user-menu`
                    })}
                >
                    {profile ? (
                        <>
                            <button
                                {...createButtonProps({
                                    className: isOpen ? styles.active : undefined
                                })}
                            >
                                <FaUserCircle size="2rem" />
                                <span className={styles.tip} role="tooltip">
                                    {profile.name}
                                </span>
                            </button>
                            {isOpen ? (
                                <>
                                    <ul {...createMenuProps()}>
                                        <li className={styles.inactive}>
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                paddingBottom: "0.5em",
                                                borderBottom: "1px solid #ddd"
                                            }}>
                                                <strong>{profile.name}</strong>
                                                <small>{profile.email}</small>
                                            </div>
                                        </li>
                                        <li {...createItemProps({ onClick: handleProfile })}>
                                            Edit Profile...
                                        </li>
                                        <li {...createItemProps({ onClick: handleSignOut })}>
                                            Sign Out
                                        </li>
                                    </ul>
                                </>
                            ) : null}
                        </>
                    ) : null}
                </nav>
            )}
        </DropMenu>
    );
}
